export default __webpack_public_path__ + "static/media/03_DAIF_Eco_01_02.d9ad212f.mp4";